import React, { Component, PropTypes } from 'react'
import styled from 'styled-components'
import { translate } from 'react-i18next'
import { Metrics, Fonts, Colors } from '../../../Themes'
import Button from '../../../components/Button'
import { generateNCNDAWebsiteAgreement } from '../../../sources/ContractsSource'
import Modal from '../../../components/Modal'
import { uploadNda } from '../../../sources/AdminSource'
import Loader from '../../../components/Loader'

const Error = styled.div`
  margin-bottom: ${Metrics.margins.small};
  ${Fonts.style.Input};
  color: ${Colors.red};
`

const OrderedList = styled.ol`
  padding-left: 0;
  ${Fonts.style.Text};
  line-height: 1.8;

  counter-reset: item;
  li:before {
    content: counters(item, ".") ".";
    counter-increment: item;
  }
  ol {
    padding-left: ${Metrics.margins.medium};
  }

  li {
    padding-bottom: ${Metrics.margins.small};
    display: block;
    margin: ${Metrics.margins.small} 0;
    border-bottom: none;
  }
`

const Terms = styled.div`
  ${Fonts.style.Text};
  margin-top: ${Metrics.margins.base};
`

const ListTitle = styled.b`
  ${Fonts.style.Header};
  letter-spacing: 0;
`

const CustomModal = styled(Modal)`
  .modalContainer {
    width: 90%;
    max-height: 100%;

    @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
      max-height: 100vh;
      width: 100vw;
    }
  }
  #modal-body {
    max-height: 650px;
    text-align: left;

    @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
      height: calc(100vh - 68px);
      width: 100vw;
      max-height: none;
      box-shadow: none;
    }
  }
`

const CustomButton = styled(Button)`
  margin-right: ${Metrics.margins.small};
  float: left;

  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    float: none;
    margin-left: calc((100% - 118px)/2);
  }
`

const Header = styled.div`
  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    font-size: 16px;
  }
`

const Parties = styled.div`text-align: left;`

const Disclaimer = styled.div`text-align: right;`

const Party = styled.div`
  text-align: left;
  margin-top: ${Metrics.margins.base};
`

const Filler = styled.div`margin-top: ${Metrics.margins.base};`

const DownloadButton = styled.a`
  margin-right: ${Metrics.margins.small};
  float: left;
  width: ${props => (props.fullWidth ? '100%' : 'auto')};
  display: inline-block;
  border: 1px solid ${Colors.primary};
  border-radius: 0;
  padding: ${Metrics.margins.small} ${Metrics.margins.large};
  background: transparent;
  cursor: pointer;
  outline: none;
  text-transform: uppercase;
  text-decoration: none;
  ${Fonts.style.Button};
  color: ${Colors.primary};
  pointer-events: all;

  &:hover {
    border: 1px solid transparent;
    background: ${Colors.primary};
    color: ${Colors.white};
  }

  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    float: none;
    margin-left: calc((100% - 118px)/2);
  }
`

const UploadButton = styled.label`
  ${Fonts.style.Button};
  width: auto;
  display: inline-block;
  border: 1px solid transparent;
  padding: ${Metrics.margins.small} ${Metrics.margins.large};
  background: ${Colors.black};
  cursor: pointer;
  color: ${Colors.white};
  outline: none;
  text-transform: uppercase;

  &:hover {
    border: 1px solid ${Colors.black};
    background: transparent;
    color: ${Colors.black};
  }
`

const NdaContainer = styled.div`
  position: relative;
  float: left;
  cursor: pointer !important;
  input {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }

  label {
    display: block;
    @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
      display: none;
    }
  }
  span {
    display: none;
    ${Fonts.style.Text};
    color: ${Colors.darkGrey};
    @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
      display: block;
    }
  }

  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    float: none;
    text-align: center;
    margin-top: ${Metrics.margins.base};
  }
`

const MgTop20 = styled.div`
  margin-top: 20px;
  p {
    line-height: 1.8;
  }
`

const LoaderContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
`

const AlertText = styled.p`color: ${Colors.red} !important;`

class NCNDA extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: false,
      url: '',
      error: ''
    }
    this.generateNCNDA = this.generateNCNDA.bind(this)
    this.handleUploadNda = this.handleUploadNda.bind(this)
  }
  generateNCNDA () {
    const { profile } = this.props

    this.setState(
      {
        loading: true
      },
      () => {
        generateNCNDAWebsiteAgreement({
          name: `${profile.firstName} ${profile.lastName}`,
          company: profile.company,
          address: profile.address,
          country: profile.country,
          city: profile.city,
          phoneNumber: profile.phoneNumber,
          email: profile.email,
          jobTitle: profile.jobTitle
        })
          .then(response => {
            this.setState({
              loading: false,
              url: response.data.url
            })
          })
          .catch(console.error)
      }
    )
  }

  handleUploadNda (event) {
    let { profile, next, router, t } = this.props
    let file = event.target.files[0]
    if (file) {
      this.setState({ loading: true }, () => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onloadend = () => {
          profile.nda = file
          this.setState({ loading: true }, () => {
            return uploadNda(profile)
              .then(response => {
                if (router.location.query.state) {
                  next(`/landing/signup/success?state=success`)
                } else {
                  next('/landing/signup/success')
                }
              })
              .catch(error => {
                console.log(error)
                this.setState({
                  loading: false,
                  error: t('There was a problem on uploading the file.')
                })
              })
          })
        }
      })
    }
  }

  render () {
    const { t, profile, router } = this.props
    const { loading, error } = this.state
    return (
      <CustomModal
        visible
        closeAction={() => router.push('/landing')}
        header={
          <Header className={'header'}>
            {t('Non-Disclosure and Fee Agreement')}
          </Header>
        }
        backAction={router.goBack}>
        {loading && (
          <LoaderContainer>
            <Loader visible={loading} />
          </LoaderContainer>
        )}
        <Terms>
          <Parties>
            <div>
              <Filler>Between</Filler>
              <Party>
                <b>HvB Investments AG</b>, Münsterhof 6, 8001 Zurich,
                Switzerland (“<b>HvB</b>”)
              </Party>
              <Filler>and</Filler>
              <Party>
                <b>
                  {profile.company ||
                    `${profile.firstName} ${profile.lastName}`}
                </b>
                {profile.address ? `, ${profile.address}` : ''}
                {profile.city ? `, ${profile.city}` : ''}
                {profile.country ? `, ${profile.country}` : ''}
              </Party>
              <Disclaimer>
                (Individually a “<b>Party</b>”, together the “<b>Parties</b>”)
              </Disclaimer>
            </div>
          </Parties>

          <MgTop20>
            <p>Background</p>
            <p>
              Whereby{' '}
              {profile.company ||
                `${profile.firstName} ${profile.lastName}`}{' '}
              requested access to information on assets in the portfolio of HvB.
            </p>
            <p>
              Whereby the Parties desire to disclose, on a confidential basis,
              certain information, process, clients, business contacts and
              documents considered confidential and/or proprietary by the
              Parties concerning their respective businesses.
            </p>
            <p>
              The Parties wish to maintain the confidentiality and/or the
              proprietary nature of the confidential information disclosed.
            </p>
            <p>
              By this Agreement, the Parties wish to set the basis for a lasting
              business relationship.
            </p>
            <p>
              <b>The Parties agree on the following:</b>
            </p>

            <OrderedList>
              <li>
                <ListTitle>Definitions</ListTitle>
                <OrderedList>
                  <li>
                    <b>“Business Associates”</b> means, business affiliates,
                    investors, financers, Clients, employees, vendors, asset
                    owners, Intermediaries and any other third party relations.
                  </li>
                  <li>
                    <b>“Client”</b> means third parties directly interested in
                    acquiring or selling real estate or other assets.
                  </li>
                  <li>
                    <b>“Commission”</b> means, any monetary compensation paid by
                    a Client, a Business Associate or any other person and/or
                    entity in consideration of introductions made and/or
                    transactions successfully closed.
                  </li>
                  <li>
                    <b>"Commission"</b> means any and all information disclosed
                    orally or in writing or made available by any Party
                    ("Disclosing Party") to another Party ("Recipient") so long
                    as not explicitly designated as not confidential by the
                    Disclosing Party. In addition, the existence and terms of
                    this Agreement shall also be treated as Confidential
                    Information.
                  </li>
                  <li>
                    <b>"Total Commission"</b> means the pot composed of both
                    buyer and seller side commission.
                  </li>
                  <li>
                    <b>"Transaction"</b> means, the sale of one (1) asset either
                    directly listed in HvB’s portfolio or sold through or by a
                    Business Associate and/or a Client of HvB.
                  </li>
                </OrderedList>
              </li>
              <li>
                <ListTitle>Confidentiality and Non-Disclosure</ListTitle>
                <OrderedList>
                  <li>
                    The Parties agree to maintain the confidentiality of the
                    Confidential Information and to prevent its unauthorized
                    dissemination or use, subject to the exceptions enumerated
                    in Section 2.5. of this Agreement.
                  </li>
                  <li>
                    The Parties agree not to use the Confidential Information
                    for purposes other than that necessary to consider and
                    enable the business relationship or pursue transaction
                    between or involving the Parties or one of the Parties.
                  </li>
                  <li>
                    The Recipient shall protect the Confidential Information by
                    using the same degree of care, but no less than reasonable
                    care, to prevent the unauthorized use, dissemination or
                    publication of the Confidential Information as the Recipient
                    uses to protect its own Confidential Information.
                  </li>
                  <li>
                    The Recipient shall limit its internal disclosure of the
                    Confidential Information to only those employees,
                    accountants, attorneys and affiliates who have a need to
                    know the information for the limited purpose of the proposed
                    business relationship or transaction between the Parties.
                  </li>
                  <li>
                    This Agreement shall impose no obligations with respect to
                    Confidential Information which:
                    <ol>
                      <li>
                        is disclosed with the prior written consent of the
                        Disclosing Party;
                      </li>
                      <li>
                        is now, or hereafter becomes, through no act or failure
                        to act on the part of the Recipient, generally known or
                        available to the public;
                      </li>
                      <li>
                        was already known by Recipient before receiving such
                        information from the Disclosing Party, as evidenced by
                        written documents;
                      </li>
                      <li>
                        is information which the Recipient can document was
                        independently developed by the Recipient without
                        reference to or use of any Confidential Information
                        received from the Disclosing Party;
                      </li>
                      <li>
                        is required to be disclosed pursuant governmental
                        agencies or law. In such cases, the Recipient seeking to
                        disclose Confidential Information will provide to the
                        Disclosing Party notice prior to such disclosure so as
                        to afford the Disclosing Party a reasonable opportunity
                        to file objections to the disclosure with the
                        appropriate agency or entity.
                      </li>
                    </ol>
                  </li>
                  <li>
                    The Recipient acknowledges and agrees that all the
                    Confidential Information of the Disclosing Party is and
                    shall remain the sole and exclusive property of the
                    Disclosing Party, free of any and all claims of the
                    Recipient.
                  </li>
                  <li>
                    Each Party shall be responsible for compliance with all
                    applicable federal, state and local (in foreign
                    jurisdictions) laws and regulations, including all
                    applicable rules of self-regulatory organizations. To the
                    extent that either Party fails to comply with such
                    regulations, it shall indemnify the other Party or parties
                    from any damages resulting from the violation.
                  </li>
                </OrderedList>
              </li>
              <li>
                <ListTitle>Non-Circumvention and Non-Solicitation</ListTitle>
                <OrderedList>
                  <li>
                    The Parties agree not to directly or indirectly circumvent
                    each other and not to work/ deal/ transact with Business
                    Associates introduced by each Party at any time, without the
                    knowledge and explicit permission of the introducing Party.
                    This clause is valid indefinitely, and is not affected by a
                    possible cancellation of this Agreement.
                  </li>
                  <li>
                    In case of unauthorized circumvention or solicitation, in
                    addition to the Commission usually due to the affected
                    Party, the violating Party is liable to pay to the affected
                    Party a penalty of 5% of the total Transaction value.
                  </li>
                  <li>
                    The payment of the penalty in no way transfers the ownership
                    of the Client or Business Associate to the violating Party.
                    Any further Transaction with the concerned Client or
                    Business Associate, without express approval of the affected
                    Party, shall trigger this penalty anew.
                  </li>
                </OrderedList>
              </li>
              <li>
                <ListTitle>Commission</ListTitle>
                <OrderedList>
                  <li>
                    {profile.company ||
                      `${profile.firstName} ${profile.lastName}`}{' '}
                    agrees to pay, in consideration for the property presented
                    by HvB, a per deal Commission of the total Transaction value
                    – as outlined for each property individually – directly to
                    HvB in case of a successful Transaction.
                  </li>
                  <li>
                    The Commission is to be paid to the account defined by HvB
                    latest 7 (seven) days after performance of the Investment.
                  </li>
                </OrderedList>
              </li>
              <li>
                <ListTitle>Validity and Termination</ListTitle>
                <OrderedList>
                  <li>
                    This Agreement shall be valid once signed by both Parties by
                    the date stated on the agreement.
                  </li>
                  <li>
                    This Agreement may be terminated by either Party for any
                    reason and at any time, by written notice given to the other
                    Party. However, any such termination shall have no effect on
                    the rights and obligations of the Parties under this
                    Agreement in respect to Transactions executed, or in the
                    process of being executed prior to such termination and
                    especially with regards to Confidential Information, client
                    and contact protection.
                  </li>
                </OrderedList>
              </li>
              <li>
                <ListTitle>Amendments</ListTitle>
                <OrderedList>
                  <li>
                    Any amendment of this Agreement shall only be valid if made
                    in written form and if signed by both Parties.
                  </li>
                </OrderedList>
              </li>
              <li>
                <ListTitle>Governing law and jurisdiction</ListTitle>
                <OrderedList>
                  <li>
                    This Agreement shall in all respects be governed by and
                    construed in accordance with Swiss law, without giving
                    effect to its conflict of law principles. All disputes
                    arising from or in connection with this Agreement, including
                    disputes regarding its conclusion, validity, binding effect,
                    amendment, breach, termination or rescission, shall be
                    subject to the exclusive jurisdiction of the courts of the
                    Canton of Zurich.
                  </li>
                </OrderedList>
              </li>
            </OrderedList>
          </MgTop20>
        </Terms>
        {error && <Error>{error}</Error>}
        {!this.state.url && (
          <CustomButton label={t('Generate')} onClick={this.generateNCNDA} />
        )}
        {this.state.url && (
          <div>
            <AlertText>Please upload the NDA signed.</AlertText>
            <DownloadButton href={this.state.url} target={'_blank'}>
              Print
            </DownloadButton>
            <NdaContainer>
              <input
                type='file'
                name='nda-upload'
                id='nda-upload'
                onChange={this.handleUploadNda}
              />
              <UploadButton htmlFor='nda-upload'>{t('Upload')}</UploadButton>
              <span>{t('Please upload the file on the web version')}</span>
            </NdaContainer>
          </div>
        )}
      </CustomModal>
    )
  }
}

NCNDA.propTypes = {
  confirmPassword: PropTypes.string,
  handleConfirm: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
  next: PropTypes.func.isRequired,
  router: PropTypes.object,
  t: PropTypes.func
}

NCNDA.defaultprops = {
  profile: {}
}

export default translate([ 'common', 'forms', 'admin' ], {
  wait: true
})(NCNDA)



// WEBPACK FOOTER //
// ./src/pages/Landing/Onboarding/NCNDA.js